/**
 * Claves estables para las opciones de un grupo de modificadores (RES-65).
 *
 * `ModifiersPage` renderizaba las opciones con `key={index}`, y `OptionConsumptionEditor` guarda
 * estado propio (panel abierto, insumo elegido, cantidad a medio tipear). Al borrar la opción 1,
 * la 2 pasaba al índice 0: React reusaba la instancia del editor y la opción que quedaba
 * aparecía con el panel abierto y los datos de la que se había borrado.
 *
 * Las opciones ya guardadas traen `id` del backend. Las nuevas todavía no tienen ninguno, así
 * que se les asigna una clave en un `WeakMap`: no toca el objeto de la opción, no llega al
 * backend y sobrevive mientras la opción siga siendo la misma (el formulario las muta en su
 * lugar, así que la identidad se conserva entre renders).
 */

const newOptionKeys = new WeakMap();
let sequence = 0;

/**
 * Clave de React de una opción.
 * @param {Object} option - Opción del grupo
 * @returns {string} Clave estable mientras la opción exista
 */
export function optionKey(option) {
  if (option?.id) return option.id;
  if (!option || typeof option !== 'object') return 'option-missing';
  if (!newOptionKeys.has(option)) {
    sequence += 1;
    newOptionKeys.set(option, `new-option-${sequence}`);
  }
  return newOptionKeys.get(option);
}
